export type CachedSessionUser = {
  id: number;
  email: string;
  name?: string | null;
  phone_number?: string;
  job_title?: string;
  target_objective?: string;
  onboarding_objective?: string | null;
  instagram?: string;
  tiktok?: string;
  youtube?: string;
  createdAt?: string;
  updatedAt?: string;
};

export function readCachedSessionUser(raw: string | null): CachedSessionUser | null {
  if (!raw) return null;

  try {
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;

    const record = parsed as Record<string, unknown>;
    if (typeof record.id !== 'number' || typeof record.email !== 'string') {
      return null;
    }

    return parsed as CachedSessionUser;
  } catch {
    return null;
  }
}
